module.exports = __webpack_public_path__ + "static/media/bigData.ce4b1d4c.webp";